'use strict';

require('js-base64');
require('angular-ui-tree');
require('ng-infinite-scroll');
require('isteven-angular-multiselect/isteven-multi-select');
require('ng-img-crop/compile/minified/ng-img-crop');
require('./node_modules/quill/dist/quill.js');
require('./node_modules/ng-quill/dist/ng-quill.js');

require('./prototypes/Sformat.js');

var moduleName = 'ngDro-uaa';
angular.module(moduleName, ['ngDro', 'ui.tree', 'infinite-scroll', 'isteven-multi-select', 'ngImgCrop', 'ngQuill']);

global.ngDroModules.push(moduleName);

angular.module(moduleName).config(require('./configs/TranslateProvider'));
angular.module(moduleName).config(require('./configs/StateProvider'));
angular.module(moduleName).config(require('./configs/HttpInterceptors'));

//ngDroDirectives
angular.module(moduleName).directive('ngDroUaaNoData', require('./directives/noData/noData'));
angular.module(moduleName).directive('ngDroDragAndScroll', require('./directives/dragAndScroll/dragAndScroll'));
angular.module(moduleName).directive('tableLoadMore', require('./directives/layout/tableLoadMore'));
angular.module(moduleName).directive('inputfind', require('./directives/layout/tableInputFind'));
angular.module(moduleName).directive('tableButtonAdd', require('./directives/layout/tableButtonAdd'));
angular.module(moduleName).directive('tableButtonGroupAction', require('./directives/layout/tableButtonGroupAction'));
angular.module(moduleName).directive('tableButtonGroupPerms', require('./directives/layout/tableButtonGroupActionPerms'));
angular.module(moduleName).directive('tableButtonGroupEdit', require('./directives/layout/tableButtonGroupEdit'));
angular.module(moduleName).directive('buttonmodalform', require('./directives/layout/formButton'));
angular.module(moduleName).directive('buttonmodalformnoperms', require('./directives/layout/formButtonNoPerms'));
angular.module(moduleName).directive('buttonmodalclose', require('./directives/layout/buttons/buttonClose'));
angular.module(moduleName).directive('equals', require('./directives/form/equals'));

//ngDroServices
angular.module(moduleName).factory('CanDoServices', require('./services/canDoService'));
angular.module(moduleName).factory('ngDroAnimateIt', require('./services/animate/AnimateIt'));
angular.module(moduleName).service('ngDroErrorInterceptor', require('./services/error/ErrorInterceptor'));
angular.module(moduleName).service('ngDroErrorHandler', require('./services/error/ErrorHandler'));

angular.module(moduleName).service('ngDroTemplate', require('./services/rest/template'));
angular.module(moduleName).service('ngDroUAACommon', require('./services/rest/UAACommon'));
angular.module(moduleName).service('ngDroProfile', require('./services/rest/profile'));
angular.module(moduleName).service('ngDroPerson', require('./services/rest/person'));
angular.module(moduleName).service('ngDroRole', require('./services/rest/role'));
angular.module(moduleName).service('ngDroGroup', require('./services/rest/group'));
angular.module(moduleName).service('ngDroCompany', require('./services/rest/company'));
angular.module(moduleName).service('ngDroAudit', require('./services/rest/audit'));
angular.module(moduleName).service('ngDroUAA', require('./services/rest/UAA'));


//angular.module(moduleName).filter('toMinHour', require('./filters/timeFilter').toMinHour);
//angular.module(moduleName).filter('toMinHourShort', require('./filters/timeFilter').toMinHourShort);
//angular.module(moduleName).filter('toMinHourClock', require('./filters/timeFilter').toMinHourClock);
angular.module(moduleName).filter('emptyField', require('./filters/EmptyFieldFilter'));
angular.module(moduleName).filter('companyHelper', require('./filters/CompanyFilter'));
angular.module(moduleName).filter('roleListHelper', require('./filters/RoleListHelper'));
angular.module(moduleName).filter('groupListHelper', require('./filters/GroupListHelper'));

angular.module(moduleName).filter('capitalize', require('./filters/CapitalizeFilter'));

//ngDroControllers
angular.module(moduleName).controller('ngDroUaaOn403Ctrl', require('./components/on403Loop/on403LoopCtrl'));
angular.module(moduleName).controller('ngDroUaaProfileThumbCtrl', require('./components/profile/profileDetail/tabs/thumb-form'));
angular.module(moduleName).controller('ngDroUaaProfilePasswordCtrl', require('./components/profile/profileDetail/tabs/password-form'));
angular.module(moduleName).controller('ngDroUaaProfileFormCtrl', require('./components/profile/profileDetail/tabs/profile-form'));
angular.module(moduleName).controller('ngDroUaaProfileDetailCtrl', require('./components/profile/profileDetail/profileDetailCtrl'));
angular.module(moduleName).controller('ngDroUaaTemplateDetailCtrl', require('./components/template/templateDetail/templateDetailCtrl'));
angular.module(moduleName).controller('ngDroUaaTemplateListCtrl', require('./components/template/templateList/templateListCtrl'));
angular.module(moduleName).controller('ngDroUaaAuditListCtrl', require('./components/audit/auditList/auditListCtrl'));
angular.module(moduleName).controller('ngDroUaaGroupListCtrl', require('./components/group/groupList/groupListCtrl'));
angular.module(moduleName).controller('ngDroUaaCompanyKioskCtrl', require('./components/company/companyDetail/tabs/company-kiosk'));
angular.module(moduleName).controller('ngDroUaaCompanyFormCtrl', require('./components/company/companyDetail/tabs/company-form'));
angular.module(moduleName).controller('ngDroUaaCompanyPersonCtrl', require('./components/company/companyDetail/tabs/company-person'));
angular.module(moduleName).controller('ngDroUaaCompanyDetailCtrl', require('./components/company/companyDetail/companyDetailCtrl'));
angular.module(moduleName).controller('ngDroUaaCompanyListCtrl', require('./components/company/companyList/companyListCtrl'));
angular.module(moduleName).controller('ngDroUaaRoleDetailCtrl', require('./components/role/roleDetail/roleDetailCtrl'));
angular.module(moduleName).controller('ngDroUaaRoleListCtrl', require('./components/role/roleList/roleListCtrl'));
angular.module(moduleName).controller('ngDroUaaPersonDetailCtrl', require('./components/person/personDetail/personDetailCtrl'));
angular.module(moduleName).controller('ngDroUaaPersonListCtrl', require('./components/person/personList/personListCtrl'));

//
angular.module(moduleName).run(['$rootScope', 'MainViews', 'ngDroErrorHandler', '$translate', function ($rootScope, MainViews, ngDroErrorHandler, $translate) {

        //leggo la configurazione esterna del modulo
        if (!$rootScope.configs)
            $rootScope.configs = {};
        $rootScope.configs.ngDroUAAMainConfig = global.ngDroUAAMainConfig;

        // Setto il catch degli emit di errorHandler
        ngDroErrorHandler.init();

        // $templateCache.put('config.js', require('./node_modules/ckeditor/config.js'));

        /** Registo il modulo per il menù **/
        MainViews.register({
            title: 'uaa.menu.profile',
            state: 'uaa-module-profile-detail',
            iconClass: 'fa fa-fw fa-vcard-o',
            order: 3,
            hasPerms:true
        });

        MainViews.register({
            title: 'uaa.menu.administration',
            state: 'uaa-module',
            iconClass: 'fa fa-fw fa-tasks',
            order: 100,
            children: [{
                    title: 'uaa.menu.users',
                    state: 'uaa-module-person-list',
                    iconClass: 'fa fa-fw fa-user',
                    order: 0,
                    perms: 'PERSON'
                }, {
                    title: 'uaa.menu.roles',
                    state: 'uaa-module-role-list',
                    iconClass: 'fa fa-fw fa-shield',
                    order: 1,
                    perms: 'ROLE'
                }, {
                    title: 'uaa.menu.groups',
                    state: 'uaa-module-group-list',
                    iconClass: 'fa fa-fw fa-users',
                    order: 2,
                    perms: 'GROUP'
                }, {
                    title: 'uaa.menu.companies',
                    state: 'uaa-module-company-list',
                    iconClass: 'fa fa-fw fa-sitemap',
                    order: 3,
                    perms: 'COMPANY_DISTRICT'
                }, {
                    title: 'uaa.menu.templates',
                    state: 'uaa-module-template-list',
                    iconClass: 'fa fa-fw fa-inbox',
                    order: 4,
                    perms: 'TEMPLATE'
                }, {
                    title: 'uaa.menu.audit',
                    state: 'uaa-module-audit-list',
                    iconClass: 'fa fa-fw fa-bell-o',
                    order: 5,
                    perms: 'AUDIT'
                }]
        });

    }]);


//// test
//angular.module(moduleName).controller('ngDroUaaTestProfileRESTCtrl', require('./components/test/testProfileREST/testProfileRESTCtrl'));
//angular.module(moduleName).controller('ngDroUaaTestRoleRESTCtrl', require('./components/test/testRoleREST/testRoleRESTCtrl'));
//angular.module(moduleName).controller('ngDroUaaTestCompanyRESTCtrl', require('./components/test/testCompanyREST/testCompanyRESTCtrl'));
//angular.module(moduleName).controller('ngDroUaaTestGroupRESTCtrl', require('./components/test/testGroupREST/testGroupRESTCtrl'));
//angular.module(moduleName).controller('ngDroUaaTestPersonRESTCtrl', require('./components/test/testPersonREST/testPersonRESTCtrl'));
//angular.module(moduleName).controller('ngDroUaaTestTemplateRESTCtrl', require('./components/test/testTemplateREST/testTemplateRESTCtrl'));
//
//angular.module(moduleName).run(['MainViews', function (MainViews) {
//        MainViews.register({
//            title: 'Test',
//            state: 'test-module',
//            iconClass: 'fa fa-fw fa-bug',
//            order: 4,
//            children: [
//                {
//                    title: 'RoleREST',
//                    state: 'uaa-module-test-role',
//                    iconClass: 'fa fa-fw fa-bug',
//                    order: 0
//                }, {
//                    title: 'ProfileREST',
//                    state: 'uaa-module-test-profile',
//                    iconClass: 'fa fa-fw fa-bug',
//                    order: 1
//                }, {
//                    title: 'CompanyREST',
//                    state: 'uaa-module-test-company',
//                    iconClass: 'fa fa-fw fa-bug',
//                    order: 2
//                }, {
//                    title: 'GroupREST',
//                    state: 'uaa-module-test-group',
//                    iconClass: 'fa fa-fw fa-bug',
//                    order: 3
//                }, {
//                    title: 'PersonREST',
//                    state: 'uaa-module-test-person',
//                    iconClass: 'fa fa-fw fa-bug',
//                    order: 4
//                }
//                , {
//                    title: 'TemplateREST',
//                    state: 'uaa-module-test-template',
//                    iconClass: 'fa fa-fw fa-bug',
//                    order: 5
//                }
//            ]
//        });
//    }]);



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/module.js
// module id = 336
// module chunks = 0